export const CONTACT_EMAIL = "contact@togglecampus.com";
export const CONTACT_PHONE = "02-6010-0731";
export const CONTACT_HOURS = "평일 10:00 - 19:00";
